import { gql } from "@apollo/client"
import { TerminalType } from "../../../utils/models"

// TODO not all data is returned
export type GetTerminalReportQuery = {
  terminals: {
    edges: TerminalType[]
  }
}

export const GET_TERMINAL_REPORT = gql`
  query GetTerminalReport($ids: [ID]) {
    terminals: allTerminals(terminalIds: $ids) {
      edges {
        id
        nickname
        modemSn
        serialNumber
        organization {
          name
        }
        apiTerminal {
          singlePlans {
            totalDataUsage
            parentSharedPlan {
              id
            }
          }
          latestDataPlan {
            __typename
            ... on SingleDataPlanType {
              name
              totalDataUsage
              volumeAllowedAggregated
              volumeTotalAggregated
              volumeTopupAggregated
              start
              end
              id
            }
            ... on SharedDataPlanType {
              name
              totalDataUsage
              volumeAllowedAggregated
              volumeTotalAggregated
              volumeTopupAggregated
              start
              end
              id
            }
          }
        }
      }
    }
  }
`
